import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';

import Tags from './components/Tags';
import Color from './components/Color';
import Badges from './components/Badges';
import Price from './components/Price';
import ApplicationButtons from './components/ApplicationButtons';
import Status from './components/Status';
import Credit from './components/Credit';
import Subtitle from './components/Subtitle';
import Title from './components/Title';

function SidePanelNew() {
  return (
    <Component>
      <Container>
        <Title />
        <Subtitle />
        <Tags />
        <Color />
        <Badges />
        <Status />
        <Price />
        <ApplicationButtons />
        <Credit />
      </Container>
    </Component>
  );
}

export default SidePanelNew;

const Component = styled.div`
  flex: 1 1 460px;
  max-width: 460px;
  margin-left: 40px;

  ${media.tablet(css`
    flex: auto;
    max-width: none;
    margin: 25px 0 0;
  `)}
`;

const Container = styled.div`
  position: sticky;
  top: 25px;
`;
